import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import Select from "react-select";
import "./edit.css";

import { setLoading } from "../../../reducer/auth/auth";
import { saveMediaSubmission, fetchMetaData } from "../../../services/medium";
import { capatilizeLetter } from "../../../utils/helpers";
import { toast } from "react-toastify";

const initialValues = {

  url: "",
  description: "",
  title: "",
  why_submitting_url: "",
  why_submitting_detail: "",
  recommended_audience: [],
  content_type: "",

};

export default function UrlSubmissionProfile() {
  const { email } = useSelector((state) => state.user.user);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [countryData, setCountryData] = useState([]);



  const RegisterUser = async (formData, resetForm) => {
    console.log(formData);
    dispatch(setLoading(true));
    const {

      url,
      description,
      why_submitting_url,
      why_submitting_detail,
      recommended_audience,
      content_type,
      title

    } = formData;
    let body = {

      url: url,
      title: title,
      description: description,
      reason: why_submitting_url,
      other_reason: why_submitting_detail,
      recommend_audience: recommended_audience.join(","),
      content_type: content_type,
    };
    saveMediaSubmission(body).then((data) => {
      if (data.data.status) {
        toast.success(data.data.message, { position: "top-center" });
        dispatch(setLoading(false));
        resetForm();

        // setTimeout(() => {
        //     setOpenCopy2(false);
        // }, 100);
      }
      else {
        dispatch(setLoading(false));
        toast.error(data.data.message, { position: "top-center" });
      }

    }).catch(() => {
      dispatch(setLoading(false));
      toast.error("Something went wrong", { position: "top-center" });
    })
  };
  const capatilizeLetters = (e, name, setFieldValue, uservalues) => {
    let values = e.target.value;
    const input = values;
    setFieldValue(name, input);
  };
  let debounceTimer;

const debounce = (func, delay) => {
  return (...args) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
  const debouncedCheckUrl = useCallback(
  debounce(async (inputValue, setFieldValue, dispatch) => {
    setFieldValue("title", "");
        setFieldValue("description", "");
    if (!inputValue) return;
    dispatch(setLoading(true));
    try {
      const body = { url: inputValue };
      const data = await fetchMetaData(body);
      if (data.data.status) {
        const { title, description } = data.data.data;
        setFieldValue("title", title || "");
        setFieldValue("description", description || "");
      } else {
        console.log(data.data.message);
      }
    } catch (err) {
      console.log("Error in metadata fetch", err);
    } finally {
      dispatch(setLoading(false));
    }
  }, 500), // debounce delay
  []
);
  return (
    <>
      <div className="back-btn-profile ml-5 container-fluid">
        <span className="back-handler pointer" onClick={() => navigate(-1)}>
          <img src="../images/arrow-back.png" alt="go back" />
          Go Back
        </span>
      </div>

      <div className="login-register-saction registernew">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="login-saction-right register-right register-clint">
                <div className="form-l---r">
                  <Formik
                    initialValues={initialValues}
                    validate={(values) => {
                      const errors = {};

                      if (!values.url) errors.url = "Required";
                        if (!values.content_type) {
                            errors.content_type = "Required";
                          }
                          if (!values.why_submitting_url) {
                              errors.why_submitting_url = "Required";
                            }
                            if (values.recommended_audience.length === 0) {
                              errors.recommended_audience = "Required";
                            }
                          

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      RegisterUser(values, resetForm);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit}>


                        <div className="from-fild">

                          <label htmlFor="url">URL*</label>
                          <input
                            className={`${errors.url &&
                              touched.url &&
                              errors.url
                              ? "error-boundry"
                              : ""
                              } url-input-info`}
                           onChange={async (e) => {
                                const inputValue = e.target.value;

                                // Capitalize if needed
                                capatilizeLetters(e, "url", setFieldValue);

                                // Call API after user types
                                await debouncedCheckUrl(inputValue, setFieldValue, dispatch); 
                              }}
                            onBlur={handleBlur}
                            value={values.url}
                            type="text"
                            id="url"
                            name="url"
                            placeholder="URL"
                          />
                          <span className="error">
                            {errors.url &&
                              touched.url &&
                              errors.url}
                          </span>
                        </div>
                        <div className="from-fild">

                          <label htmlFor="title">Title</label>
                          <input
                            className={`${errors.title &&
                              touched.title &&
                              errors.title
                              ? "error-boundry"
                              : ""
                              } url-input-info`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            type="text"
                            id="title"
                            name="title"
                            placeholder="Title"
                          />
                          <span className="error">
                            {errors.title &&
                              touched.title &&
                              errors.title}
                          </span>
                        </div>

                        <div className="full-fild">
                          <label htmlFor="description">Description</label>
                          <textarea
                            className={`textarea-field ${errors.description && touched.description ? "error-boundry" : ""
                              }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            id="description"
                            name="description"
                            placeholder="Enter Description"
                            rows="10"
                            style={{ width: "90%" }}
                          />
                          <span className="error">
                            {errors.description && touched.description && errors.description}
                          </span>
                        </div>
                        <div className="full-fild mt-2">
                          <label>
                            Why are you submitting this URL? <i>*</i>
                          </label>
                          <div className="InputGroup">
                            <div className="radio-box">
                              <input
                                type="radio"
                                name="why_submitting_url"
                                id="why_1"
                                value="About VerySoul"
                                className="url-input-info"
                                checked={values.why_submitting_url === "About VerySoul"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="why_1">About VerySoul</label>
                            </div>

                            <div className="radio-box">
                              <input
                                type="radio"
                                name="why_submitting_url"
                                className="url-input-info"
                                id="why_2"
                                value="Mentions VerySoul"
                                checked={values.why_submitting_url === "Mentions VerySoul"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="why_2">Mentions VerySoul</label>
                            </div>

                            <div className="radio-box">
                              <input
                                type="radio"
                                name="why_submitting_url"
                                className="url-input-info"
                                id="why_3"
                                value="Aligns with VerySoul Mission"
                                checked={values.why_submitting_url === "Aligns with VerySoul Mission"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="why_3">Aligns with VerySoul Mission</label>
                            </div>

                            <div className="radio-box">
                              <input
                                type="radio"
                                name="why_submitting_url"
                                className="url-input-info"
                                id="why_4"
                                value="Other Reason"
                                checked={values.why_submitting_url === "Other Reason"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="why_4">Other Reason</label>
                            </div>
                          </div>

                          <span className="error text-left">
                            {errors.why_submitting_url &&
                              touched.why_submitting_url &&
                              errors.why_submitting_url}
                          </span>
                        </div>
                        {(values.why_submitting_url === "Aligns with VerySoul Mission" ||
                          values.why_submitting_url === "Other Reason") && (
                            <div className="full-fild mt-2">
                              <label htmlFor="why_submitting_detail">Other Reason</label>
                              <input
                                type="text"
                                name="why_submitting_detail"
                                id="why_submitting_detail"
                                value={values.why_submitting_detail}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter reason"
                                className={`${errors.why_submitting_detail && touched.why_submitting_detail
                                  ? "error-boundry"
                                  : ""
                                  } url-input-info`}
                              />
                              <span className="error text-left">
                                {errors.why_submitting_detail &&
                                  touched.why_submitting_detail &&
                                  errors.why_submitting_detail}
                              </span>
                            </div>
                          )}
                        <div className="full-fild mt-2">
                          <label>
                            Recommended Audience <i>*</i>
                          </label>
                          <div className="InputGroup InputGroup-url-checkbox">
                            <div className="radio-box radio-box-url">
                              <input
                                type="checkbox"
                                id="audience_clients"
                                name="recommended_audience"
                                value="Clients"
                                checked={values.recommended_audience.includes("Clients")}
                                onChange={(e) => {
                                  const { value, checked } = e.target;
                                  const updated = checked
                                    ? [...values.recommended_audience, value]
                                    : values.recommended_audience.filter((v) => v !== value);
                                  setFieldValue("recommended_audience", updated);
                                }}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="audience_clients">Clients</label>
                            </div>

                            <div className="radio-box radio-box-url">
                              <input
                                type="checkbox"
                                id="audience_public"
                                name="recommended_audience"
                                value="General Public"
                                checked={values.recommended_audience.includes("General Public")}
                                onChange={(e) => {
                                  const { value, checked } = e.target;
                                  const updated = checked
                                    ? [...values.recommended_audience, value]
                                    : values.recommended_audience.filter((v) => v !== value);
                                  setFieldValue("recommended_audience", updated);
                                }}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="audience_public">General Public</label>
                            </div>

                            <div className="radio-box radio-box-url">
                              <input
                                type="checkbox"
                                id="audience_mediums"
                                name="recommended_audience"
                                value="Mediums"
                                checked={values.recommended_audience.includes("Mediums")}
                                onChange={(e) => {
                                  const { value, checked } = e.target;
                                  const updated = checked
                                    ? [...values.recommended_audience, value]
                                    : values.recommended_audience.filter((v) => v !== value);
                                  setFieldValue("recommended_audience", updated);
                                }}
                                onBlur={handleBlur}
                              />
                              <label htmlFor="audience_mediums">Mediums</label>
                            </div>
                          </div>

                          <span className="error text-left">
                            {errors.recommended_audience &&
                              touched.recommended_audience &&
                              errors.recommended_audience}
                          </span>
                        </div>
                        <div className="full-fild mt-2">
                          <label htmlFor="content_type">
                            Content Type <i>*</i>
                          </label>
                          <select
                            className={`selectmenu-element form-item__element--select has-placeholder ${errors.content_type && touched.content_type ? "error-boundry" : ""
                              } url-input-info url-input-info-select`}
                            name="content_type"
                            id="content_type"
                            value={values.content_type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option disabled value="">
                              Select Content Type
                            </option>
                            <option value="Blog Post">Blog Post</option>
                            <option value="Social Media Post (Instagram, LinkedIn, X)">
                              Social Media Post (Instagram, LinkedIn, X)
                            </option>
                            <option value="YouTube">YouTube</option>
                            <option value="Podcast">Podcast</option>
                            <option value="Email Newsletter">Email Newsletter</option>
                            <option value="Infographic">Infographic</option>
                            <option value="Reel / Short / TikTok">Reel / Short / TikTok</option>
                            <option value="Webinar">Webinar</option>
                            <option value="Case Study">Case Study</option>
                            <option value="E-book / Guide">E-book / Guide</option>
                            <option value="Testimonial (Text or Video)">
                              Testimonial (Text or Video)
                            </option>
                            <option value="Live Stream (Instagram, Facebook, LinkedIn)">
                              Live Stream (Instagram, Facebook, LinkedIn)
                            </option>
                            <option value="Quiz / Poll">Quiz / Poll</option>
                            <option value="Whitepaper">Whitepaper</option>
                            <option value="Explainer Video">Explainer Video</option>
                            <option value="Product Demo">Product Demo</option>
                            <option value="Slide Deck / Presentation">
                              Slide Deck / Presentation
                            </option>
                            <option value="Press Release">Press Release</option>
                            <option value="Interactive Tool (calculator, checklist)">
                              Interactive Tool (calculator, checklist)
                            </option>
                            <option value="News Article / Editorial">
                              News Article / Editorial
                            </option>
                          </select>
                          <span className="error">
                            {errors.content_type && touched.content_type && errors.content_type}
                          </span>
                        </div>
                        <div className="bution">
                          <button type="submit" className="button-bx">
                            Submit
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
